export default class PrognosisPQValues {
    // mPointIds: number[] = [];
    constructor(prognosisForTime = new Date(), pVal = NaN, qVal = NaN) {
        this.prognosisForTime = prognosisForTime;
        this.pVal = pVal;
        this.qVal = qVal;
    }
}
